export enum SatisfyEnum{
  NONE = 'NONE',
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE'
}
